import { useState, useEffect, useMemo, useCallback } from "react";
import { listItemSelectBuilder } from "@wix/design-system";
import { useTranslation } from "react-i18next";
import { useTheme, type ThemeOption } from "@wix/picasso-common";

interface UseThemeDropdownProps {
  onClose: () => void;
}

export const useThemeDropdown = ({ onClose }: UseThemeDropdownProps) => {
  const { t } = useTranslation();
  const { toggleTheme, themeOption } = useTheme();
  const [selectedThemeOption, setSelectedThemeOption] =
    useState<ThemeOption>(themeOption);

  const handleThemeSelect = useCallback(
    (selectedTheme: ThemeOption) => {
      setSelectedThemeOption(selectedTheme);
      toggleTheme(selectedTheme);
      onClose();
    },
    [toggleTheme, onClose],
  );

  const themeOptions = useMemo(
    () => [
      listItemSelectBuilder({
        id: "light",
        title: t("landing.themeToggle.light"),
        selected: selectedThemeOption === "light",
        size: "small",
      }),
      listItemSelectBuilder({
        id: "dark",
        title: t("landing.themeToggle.dark"),
        selected: selectedThemeOption === "dark",
        size: "small",
      }),
      listItemSelectBuilder({
        id: "system",
        title: t("landing.themeToggle.device"),
        selected: selectedThemeOption === "system",
        size: "small",
      }),
    ],
    [t, selectedThemeOption],
  );

  return {
    selectedThemeOption,
    handleThemeSelect,
    themeOptions,
  };
};
